/**
 * Returns the short code for a department (e.g. "BTM").
 * Falls back to the full name if no code is set.
 */
export function deptCode(dept) {
  return dept?.offerCode || dept?.name || '';
}

/**
 * Returns a display label: "BTM – BuildTech Management" if code exists,
 * otherwise just the name.
 */
export function deptLabel(dept) {
  if (!dept) return '';
  if (dept.offerCode) return `${dept.offerCode} – ${dept.name}`;
  return dept.name;
}
